export const PHONE_NUMBER_PATTERN = /^\+32 \d{3} \d{2} \d{2} \d{2}$/;
